export default "__VITE_ASSET__KKjyPTMm__"